/* weartheclouds theme: shopping interactions.
   Cart drawer, quick add, quick view, search, filters, cap finder, product page extras.
   Every feature falls back to normal links and forms if this file fails to load. */
(function () {
  'use strict';

  var C = window.WTC_CONFIG || {};
  var R = C.routes || {};
  R.root = R.root || '/';
  R.cart = R.cart || '/cart';
  R.cartAdd = R.cartAdd || '/cart/add';
  R.cartChange = R.cartChange || '/cart/change';
  R.search = R.search || '/search';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- helpers ---------- */
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function rootUrl(path) { return R.root.replace(/\/$/, '') + path; }
  function sized(src, w) {
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(cents) {
    var fmt = String(C.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    var v = (Number(cents) || 0) / 100;
    function fix(n, d, ts, ds) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fix(v, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(v, 2, "'", '.');
        default: return fix(v, 2, ',', '.');
      }
    });
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  /* ---------- colours, designs, styles ---------- */
  var COLOURS = [
    ['dark grey', 'Dark grey', '#4A4845', 'dark'], ['royal blue', 'Royal blue', '#2747A8', 'pop'],
    ['burgundy', 'Burgundy', '#6E1F2B', 'pop'], ['mustard', 'Mustard', '#C9962B', 'pop'],
    ['navy', 'Navy', '#1F2A44', 'dark'], ['black', 'Black', '#141210', 'dark'],
    ['camo', 'Camo', '#5F6148', 'dark'], ['olive', 'Olive', '#5B6B4A', 'dark'],
    ['brown', 'Brown', '#6B4A33', 'dark'], ['khaki', 'Khaki', '#B8A98A', 'light'],
    ['stone', 'Stone', '#D8CCB6', 'light'], ['beige', 'Beige', '#D9C8A9', 'light'],
    ['cream', 'Cream', '#EFE6D2', 'light'], ['white', 'White', '#F4F1EA', 'light'],
    ['grey', 'Grey', '#9A9893', 'dark'], ['gray', 'Grey', '#9A9893', 'dark'],
    ['green', 'Green', '#4F6B4A', 'pop'], ['blue', 'Blue', '#2F5BA8', 'pop'],
    ['red', 'Red', '#B3261E', 'pop'], ['pink', 'Pink', '#E7A2B0', 'pop'],
    ['orange', 'Orange', '#D9682B', 'pop'], ['yellow', 'Yellow', '#E5C53B', 'pop']
  ];
  function colourOf(text, tags) {
    var t = (tags || []).filter(function (x) { return /^colou?r:/i.test(x); })[0];
    var hay = (t ? t.split(':')[1] : String(text || '')).toLowerCase();
    var best = null, bestPos = 1e9;
    COLOURS.forEach(function (c) {
      var re = new RegExp('(^|[^a-z])' + c[0] + '(?![a-z])');
      var m = re.exec(hay);
      if (!m) return;
      var pos = m.index + m[1].length;
      if (pos < bestPos || (pos === bestPos && c[0].length > best[0].length)) { best = c; bestPos = pos; }
    });
    return best ? { key: best[1].toLowerCase(), name: best[1], hex: best[2], tone: best[3] } : null;
  }
  function styleOf(type) {
    var t = String(type || '').toLowerCase();
    if (t.indexOf('trucker') > -1) return { key: 'trucker', name: 'Trucker' };
    if (t.indexOf('vintage') > -1) return { key: 'vintage', name: 'Vintage dad', group: 'dad' };
    if (t.indexOf('dad') > -1) return { key: 'dad', name: 'Dad cap', group: 'dad' };
    if (t.indexOf('classic') > -1) return { key: 'classic', name: 'Classic' };
    return t ? { key: t, name: type } : null;
  }
  function info(p) {
    var parts = String(p.title || '').split('|');
    var design = parts[0].trim();
    var colourway = parts.length > 1 ? parts[1].replace(/-\s*LIMITED/i, '').trim() : (p.type || '');
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(',');
    var limited = /LIMITED/i.test(p.title) || tags.some(function (t) { return /^limited$/i.test(String(t).trim()); });
    return { design: design, colourway: colourway, limited: limited, colour: colourOf(colourway, tags), style: styleOf(p.type) };
  }

  /* ---------- catalogue ---------- */
  var catalog = [];
  try { catalog = JSON.parse(($('#wtc-catalog') || {}).textContent || '[]'); } catch (e) { catalog = []; }
  catalog.forEach(function (p) { p.info = info(p); });
  function fromCatalog(handle) { return catalog.filter(function (p) { return p.handle === handle; })[0]; }
  function normalizeJs(j) {
    var v = (j.variants || []).filter(function (x) { return x.available; })[0] || (j.variants || [])[0] || {};
    var p = {
      handle: j.handle, url: j.url || rootUrl('/products/' + j.handle), title: j.title, type: j.type,
      price: j.price, compare: j.compare_at_price, available: j.available, variant: v.id,
      tags: j.tags || [], images: (j.images || []).map(function (s) { return /^\/\//.test(s) ? 'https:' + s : s; }),
      desc: String(j.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240)
    };
    p.info = info(p);
    return p;
  }
  function getProduct(handle) {
    var p = fromCatalog(handle);
    if (p) return Promise.resolve(p);
    return fetch(rootUrl('/products/' + encodeURIComponent(handle) + '.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Product not found'); return r.json(); })
      .then(normalizeJs);
  }
  function siblingsOf(p) {
    return catalog.filter(function (x) { return x.info.design === p.info.design; });
  }

  function cardHTML(p, opts) {
    opts = opts || {};
    var i = p.info, img = p.images[0], alt = p.images[1];
    var name = opts.hideDesign
      ? '<strong>' + esc(i.colourway) + '</strong><span>' + esc(p.type) + '</span>'
      : '<strong>' + esc(i.design) + '</strong><span>' + esc(i.colourway) + '</span>';
    return '<article class="card" data-card data-handle="' + esc(p.handle) + '" data-design="' + esc(i.design) + '" data-type="' + esc(p.type) + '" data-colour="' + esc(i.colourway) + '" data-price="' + p.price + '" data-limited="' + i.limited + '" data-tags="' + esc((p.tags || []).join(',')) + '">' +
      '<div class="card-visual"><a class="card-media' + (alt ? ' has-alt' : '') + '" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img class="card-img" src="' + esc(sized(img, 700)) + '" alt="" loading="lazy">' : '') +
      (alt ? '<img class="card-img card-img-alt" src="' + esc(sized(alt, 700)) + '" alt="" loading="lazy">' : '') +
      (opts.badge ? '<span class="dg-tag dg-tag-match">' + esc(opts.badge) + '</span>' : (i.limited ? '<span class="dg-tag">Limited</span>' : '')) +
      '</a><div class="card-actions">' +
      '<button type="button" class="card-btn card-btn-view" data-quick-view="' + esc(p.handle) + '" aria-label="Quick view: ' + esc(p.title) + '"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" fill="currentColor"/></svg></button>' +
      (p.available !== false && p.variant ? '<form method="post" action="' + esc(R.cartAdd) + '" class="card-add"><input type="hidden" name="id" value="' + p.variant + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="card-btn card-btn-add" aria-label="Add ' + esc(p.title) + ' to cart"><span aria-hidden="true">+</span><span class="card-btn-text">Add</span></button></form>' : '') +
      '</div></div><a class="card-meta" href="' + esc(p.url) + '"><span class="card-name">' + name + '</span><span class="card-price">' + esc(money(p.price)) + '</span></a></article>';
  }

  /* ---------- overlays (drawer, modal, search, lightbox) ---------- */
  var stack = [];
  function overlay(name) {
    var el = $('[data-overlay="' + name + '"]');
    if (!el) return null;
    var panel = $('[data-panel]', el) || el;
    var last = null, timer = null;
    var api = {
      el: el,
      isOpen: function () { return el.classList.contains('is-open'); },
      open: function () {
        clearTimeout(timer);
        if (api.isOpen()) return;
        last = document.activeElement;
        el.hidden = false;
        document.documentElement.classList.add('no-scroll');
        stack.push(api);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.add('is-open');
            var f = $('[data-autofocus]', el) || panel;
            try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
          });
        });
      },
      close: function () {
        if (!api.isOpen() && el.hidden) return;
        el.classList.remove('is-open');
        stack = stack.filter(function (x) { return x !== api; });
        if (!stack.length) document.documentElement.classList.remove('no-scroll');
        timer = setTimeout(function () { if (!api.isOpen()) el.hidden = true; }, reduceMotion ? 0 : 380);
        if (last && last.focus && document.contains(last)) { try { last.focus({ preventScroll: true }); } catch (e) { last.focus(); } }
      }
    };
    el.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) api.close(); });
    return api;
  }
  document.addEventListener('keydown', function (e) {
    if (!stack.length) return;
    var top = stack[stack.length - 1];
    if (e.key === 'Escape') { e.preventDefault(); top.close(); return; }
    if (e.key === 'Tab') {
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', top.el)
        .filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !top.el.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  var drawer = overlay('cart');
  var quick = overlay('quick-view');
  var search = overlay('search');
  var lightbox = overlay('lightbox');

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast]'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-on');
      setTimeout(function () { toastEl.hidden = true; }, 300);
    }, 2600);
  }

  /* ---------- cart ---------- */
  var Cart = {
    state: null,
    req: function (url, opts) {
      opts = opts || {};
      opts.headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
      return fetch(url, opts).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
          return j;
        });
      });
    },
    get: function () {
      return Cart.req(R.cart + '.js').then(function (j) { Cart.state = j; Cart.render(); return j; });
    },
    add: function (formData) {
      return Cart.req(R.cartAdd + '.js', { method: 'POST', body: formData }).then(function (item) {
        Cart.lastAdded = item && item.handle;
        return Cart.get();
      });
    },
    change: function (key, qty) {
      return Cart.req(R.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (j) { Cart.state = j; Cart.render(); return j; });
    },
    render: function () {
      var c = Cart.state;
      if (!c) return;
      $$('[data-cart-count]').forEach(function (el) {
        if (el.textContent !== String(c.item_count)) {
          el.textContent = c.item_count;
          el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
        }
      });
      var label = $('[data-cart-count-label]');
      if (label) label.textContent = c.item_count ? '(' + c.item_count + ')' : '';
      renderShipping(c);
      renderDrawer(c);
    }
  };

  function renderShipping(c) {
    var bar = $('[data-ship-bar]');
    if (!bar) return;
    var goal = Number(C.freeShipping) || 0;
    if (!goal || !c.item_count) { bar.hidden = true; return; }
    bar.hidden = false;
    var left = goal - c.total_price;
    var pct = Math.max(4, Math.min(100, Math.round(c.total_price / goal * 100)));
    $('[data-ship-fill]', bar).style.width = pct + '%';
    bar.classList.toggle('is-done', left <= 0);
    $('[data-ship-text]', bar).innerHTML = left > 0
      ? 'You\u2019re <strong>' + esc(money(left)) + '</strong> away from free UAE delivery'
      : '<strong>Free UAE delivery unlocked</strong> \u2713';
  }

  function lineHTML(it) {
    var i = info({ title: it.product_title, type: it.product_type, tags: [] });
    var sub = i.colourway || (it.product_has_only_default_variant ? '' : it.variant_title);
    if (!it.product_has_only_default_variant && it.variant_title && i.colourway) sub += ' · ' + it.variant_title;
    var img = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
    return '<div class="line" data-key="' + esc(it.key) + '">' +
      '<a class="line-img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(sized(img, 220)) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="line-info"><a class="line-title" href="' + esc(it.url) + '">' + esc(i.design) + '</a>' +
      (sub ? '<span class="line-sub">' + esc(sub) + '</span>' : '') +
      '<div class="stepper" role="group" aria-label="Quantity for ' + esc(it.product_title) + '">' +
      '<button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="One less">\u2212</button>' +
      '<span>' + it.quantity + '</span>' +
      '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="One more">+</button></div></div>' +
      '<div class="line-end"><span class="line-price">' + esc(money(it.final_line_price)) + '</span>' +
      '<button type="button" class="line-remove" data-qty="0">Remove</button></div></div>';
  }

  function upsellFor(c) {
    if (!catalog.length) return { title: '', items: [] };
    var inCart = {};
    c.items.forEach(function (it) { inCart[it.handle] = true; });
    var anchor = c.items.length ? fromCatalog(c.items[0].handle) : null;
    var pool = catalog.filter(function (p) { return !inCart[p.handle] && p.available !== false && p.variant; });
    var title = 'You might also like';
    var picks = [];
    if (anchor) {
      picks = pool.filter(function (p) { return p.info.design === anchor.info.design; });
      if (picks.length) title = 'Same message, another colour';
      var others = pool.filter(function (p) { return p.info.design !== anchor.info.design; });
      picks = picks.slice(0, 2).concat(others.filter(function (p) {
        return p.info.style && anchor.info.style && p.info.style.key !== anchor.info.style.key;
      }).slice(0, 1), others).filter(function (p, i, a) { return a.indexOf(p) === i; });
    } else {
      picks = pool;
    }
    return { title: title, items: picks.slice(0, 3) };
  }

  function renderDrawer(c) {
    var body = $('[data-drawer-body]'), foot = $('[data-drawer-foot]');
    if (!body) return;
    if (!c.item_count) {
      var designs = [];
      catalog.forEach(function (p) { if (designs.indexOf(p.info.design) < 0) designs.push(p.info.design); });
      body.innerHTML = '<div class="drawer-empty"><p class="drawer-empty-title">Your cart is empty.</p><p class="muted">Four designs. Pick a message, then a colour.</p>' +
        (designs.length ? '<div class="drawer-designs">' + designs.slice(0, 6).map(function (d) {
          return '<a class="chip" href="' + esc(R.search) + '?q=' + encodeURIComponent(d) + '&type=product" data-search-term="' + esc(d) + '">' + esc(d) + '</a>';
        }).join('') + '</div>' : '') +
        '<a class="btn btn-dark btn-block" href="' + esc(R.all || rootUrl('/collections/all')) + '">Shop all caps</a></div>';
      foot.hidden = true;
      return;
    }
    var up = upsellFor(c);
    body.innerHTML = '<div class="lines">' + c.items.map(lineHTML).join('') + '</div>' +
      (up.items.length ? '<div class="upsell"><h3>' + esc(up.title) + '</h3><div class="upsell-row">' + up.items.map(function (p) {
        return '<div class="mini"><button type="button" class="mini-media" data-quick-view="' + esc(p.handle) + '" aria-label="Quick view: ' + esc(p.title) + '">' +
          (p.images[0] ? '<img src="' + esc(sized(p.images[0], 300)) + '" alt="" loading="lazy">' : '') + '</button>' +
          '<span class="mini-name">' + esc(p.info.colourway) + '</span><span class="mini-price">' + esc(money(p.price)) + '</span>' +
          '<form method="post" action="' + esc(R.cartAdd) + '"><input type="hidden" name="id" value="' + p.variant + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="mini-add">+ Add</button></form></div>';
      }).join('') + '</div></div>' : '');
    var wa = '';
    if (C.whatsapp) {
      var msg = 'Hi weartheclouds! I\u2019d like to order:\n' + c.items.map(function (it) {
        return '\u2022 ' + it.quantity + ' \u00d7 ' + it.product_title + (it.product_has_only_default_variant ? '' : ' (' + it.variant_title + ')');
      }).join('\n') + '\nTotal: ' + money(c.total_price);
      wa = '<a class="drawer-link" href="https://wa.me/' + esc(C.whatsapp) + '?text=' + encodeURIComponent(msg) + '" target="_blank" rel="noopener">Order on WhatsApp instead</a>';
    }
    foot.hidden = false;
    foot.innerHTML = '<div class="drawer-total"><span>Subtotal</span><strong>' + esc(money(c.total_price)) + '</strong></div>' +
      (C.tabby ? '<p class="tabby-line">or 4 interest-free payments of <strong>' + esc(money(Math.floor(c.total_price / 4))) + '</strong> with <span class="tabby-mark">tabby</span></p>' : '') +
      '<p class="drawer-note">Delivery and taxes are added at checkout.</p>' +
      '<form action="' + esc(R.cart) + '" method="post"><button type="submit" name="checkout" class="btn btn-primary btn-block">Checkout</button></form>' +
      '<div class="drawer-links"><a class="drawer-link" href="' + esc(R.cart) + '">View cart</a>' + wa + '</div>';
  }

  // quantity buttons in the drawer
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-drawer-body] [data-qty]');
    if (!b) return;
    var line = b.closest('[data-key]');
    line.classList.add('is-updating');
    Cart.change(line.getAttribute('data-key'), Number(b.getAttribute('data-qty'))).catch(function (err) {
      line.classList.remove('is-updating');
      toast(err.message);
    });
  });

  function openCart() {
    if (!drawer) { window.location.href = R.cart; return; }
    drawer.open();
    Cart.get().catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-open]');
    if (!a || !drawer || C.cartType === 'page') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    openCart();
  });

  // every add-to-cart form on the site
  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-busy', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.disabled = on;
  }
  function done(btn) {
    if (!btn) return;
    if (!btn.hasAttribute('data-orig')) btn.setAttribute('data-orig', btn.innerHTML);
    btn.classList.add('is-done');
    if (btn.classList.contains('card-btn')) btn.innerHTML = '<span aria-hidden="true">\u2713</span><span class="card-btn-text">Added</span>';
    else btn.textContent = 'Added \u2713';
    setTimeout(function () {
      btn.classList.remove('is-done');
      btn.innerHTML = btn.getAttribute('data-orig');
      btn.removeAttribute('data-orig');
    }, 1800);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (C.cartType === 'page' || !drawer || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter || $('[type="submit"]', form);
    busy(btn, true);
    Cart.add(new FormData(form)).then(function () {
      busy(btn, false);
      done(btn);
      var modal = form.closest('[data-overlay="quick-view"]');
      if (modal && quick) quick.close();
      setTimeout(function () { drawer.open(); }, modal ? 200 : 250);
    }).catch(function (err) {
      busy(btn, false);
      toast(err.message);
    });
  });

  /* ---------- quick view ---------- */
  function renderQuick(p) {
    var body = $('[data-qv-body]');
    var i = p.info;
    var sibs = siblingsOf(p);
    var imgs = p.images.length ? p.images : [''];
    body.innerHTML =
      '<div class="qv-media"><div class="qv-main"><img data-qv-main src="' + esc(sized(imgs[0], 1000)) + '" alt="' + esc(p.title) + '">' +
      (i.limited ? '<span class="dg-tag">Limited</span>' : '') + '</div>' +
      (imgs.length > 1 ? '<div class="qv-thumbs">' + imgs.slice(0, 6).map(function (src, n) {
        return '<button type="button" class="qv-thumb" data-qv-img="' + esc(sized(src, 1000)) + '" aria-label="Photo ' + (n + 1) + '" aria-pressed="' + (n === 0) + '"><img src="' + esc(sized(src, 200)) + '" alt=""></button>';
      }).join('') + '</div>' : '') + '</div>' +
      '<div class="qv-info"><span class="label-sm">' + esc(p.type || '') + '</span>' +
      '<h2 class="qv-title">' + esc(i.design) + '</h2>' +
      '<div class="qv-price-row"><span class="qv-price">' + esc(money(p.price)) + '</span><span class="qv-colour">' + esc(i.colourway) + '</span></div>' +
      (C.tabby ? '<p class="tabby-line">or 4 interest-free payments of <strong>' + esc(money(Math.floor(p.price / 4))) + '</strong> with <span class="tabby-mark">tabby</span></p>' : '') +
      (p.desc ? '<p class="qv-desc">' + esc(p.desc) + '</p>' : '') +
      (sibs.length > 1 ? '<div class="qv-sibs"><span class="label-sm">' + sibs.length + ' colours</span><div class="qv-sib-row">' + sibs.map(function (s) {
        var cur = s.handle === p.handle;
        return '<button type="button" class="qv-sib' + (cur ? ' is-current' : '') + '" data-qv-switch="' + esc(s.handle) + '" aria-pressed="' + cur + '" title="' + esc(s.info.colourway) + '">' +
          (s.images[0] ? '<img src="' + esc(sized(s.images[0], 160)) + '" alt="' + esc(s.info.colourway) + '">' : esc(s.info.colourway)) + '</button>';
      }).join('') + '</div></div>' : '') +
      (p.available !== false && p.variant
        ? '<form method="post" action="' + esc(R.cartAdd) + '" class="qv-form"><input type="hidden" name="id" value="' + p.variant + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="btn btn-primary btn-block">Add to cart \u2014 ' + esc(money(p.price)) + '</button></form>'
        : '<button type="button" class="btn btn-ghost btn-block" disabled>Sold out</button>') +
      '<a class="qv-more" href="' + esc(p.url) + '">See full details \u2192</a></div>';
  }
  function openQuick(handle) {
    if (!quick) return false;
    var body = $('[data-qv-body]');
    body.classList.add('is-loading');
    return getProduct(handle).then(function (p) {
      renderQuick(p);
      body.classList.remove('is-loading');
      quick.open();
    }).catch(function () { window.location.href = rootUrl('/products/' + handle); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quick-view]');
    if (t && quick) {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      if (t.closest('[data-overlay="cart"]')) drawer.close();
      openQuick(t.getAttribute('data-quick-view'));
      return;
    }
    var th = e.target.closest('[data-qv-img]');
    if (th) {
      $('[data-qv-main]').src = th.getAttribute('data-qv-img');
      $$('.qv-thumb').forEach(function (b) { b.setAttribute('aria-pressed', String(b === th)); });
      return;
    }
    var sw = e.target.closest('[data-qv-switch]');
    if (sw) {
      getProduct(sw.getAttribute('data-qv-switch')).then(function (p) {
        var body = $('[data-qv-body]');
        body.classList.add('is-swapping');
        setTimeout(function () {
          renderQuick(p);
          body.classList.remove('is-swapping');
          var cur = $('.qv-sib.is-current'); if (cur) cur.focus();
        }, reduceMotion ? 0 : 140);
      });
    }
  });

  /* ---------- search ---------- */
  function searchResults(q) {
    var box = $('[data-search-results]');
    if (!box) return;
    q = q.trim().toLowerCase();
    var designs = [];
    catalog.forEach(function (p) { if (designs.indexOf(p.info.design) < 0) designs.push(p.info.design); });
    if (!q) {
      box.innerHTML = designs.length ? '<span class="label-sm">Popular</span><div class="chips">' + designs.map(function (d) {
        return '<button type="button" class="chip" data-search-term="' + esc(d) + '">' + esc(d) + '</button>';
      }).join('') + ['Trucker', 'Dad cap', 'Black', 'Limited'].map(function (d) {
        return '<button type="button" class="chip" data-search-term="' + esc(d) + '">' + esc(d) + '</button>';
      }).join('') + '</div>' : '';
      return;
    }
    var words = q.split(/\s+/);
    var hits = catalog.filter(function (p) {
      var hay = [p.title, p.type, p.info.colour ? p.info.colour.name : '', p.info.limited ? 'limited' : '', (p.tags || []).join(' ')].join(' ').toLowerCase();
      return words.every(function (w) { return hay.indexOf(w) > -1; });
    });
    box.innerHTML = hits.length
      ? '<span class="label-sm">' + hits.length + ' cap' + (hits.length === 1 ? '' : 's') + '</span><div class="search-grid">' + hits.slice(0, 8).map(function (p) {
          return '<a class="search-hit" href="' + esc(p.url) + '"><span class="search-hit-img">' + (p.images[0] ? '<img src="' + esc(sized(p.images[0], 240)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="search-hit-text"><strong>' + esc(p.info.design) + '</strong><span>' + esc(p.info.colourway) + '</span></span><span class="search-hit-price">' + esc(money(p.price)) + '</span></a>';
        }).join('') + '</div>' +
        (hits.length > 8 ? '<a class="search-all" href="' + esc(R.search) + '?type=product&q=' + encodeURIComponent(q) + '">See all ' + hits.length + ' results \u2192</a>' : '')
      : '<p class="search-none">Nothing matches \u201c' + esc(q) + '\u201d. Try a colour like \u201cblack\u201d or a style like \u201ctrucker\u201d.</p>';
  }
  var sInput = $('[data-search-input]');
  if (sInput && catalog.length) {
    sInput.addEventListener('input', function () { searchResults(sInput.value); });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-search-open]');
    if (o && search) {
      e.preventDefault();
      search.open();
      if (sInput) { searchResults(sInput.value); }
      return;
    }
    var term = e.target.closest('[data-search-term]');
    if (term && sInput && search) {
      e.preventDefault();
      if (!search.isOpen()) { if (drawer && drawer.isOpen()) drawer.close(); search.open(); }
      sInput.value = term.getAttribute('data-search-term');
      searchResults(sInput.value);
      sInput.focus();
    }
  });

  /* ---------- header: sticky shadow, menu ---------- */
  (function () {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var nav = $('[data-nav]');
    if (!nav) return;
    var toggle = $('[data-nav-toggle]');
    var items = $$('[data-nav-item]', nav);
    if (toggle) toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) items.forEach(function (o) { o.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !stack.length) items.forEach(function (o) { o.open = false; });
    });
  })();

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var main = $('[data-main]', root);
    var thumbs = $$('[data-thumb]', root);
    function showMedia(id) {
      if (!main) return;
      $$('[data-media-id]', main).forEach(function (el) { el.hidden = el.getAttribute('data-media-id') !== String(id); });
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    // recently viewed: remember this product
    var handle = root.getAttribute('data-product-handle');
    if (handle) {
      var seen = (store('wtc-recent') || []).filter(function (h) { return h !== handle; });
      seen.unshift(handle);
      store('wtc-recent', seen.slice(0, 12));
      var rec = $('[data-recent]');
      if (rec && catalog.length) {
        var picks = seen.slice(1).map(fromCatalog).filter(Boolean).slice(0, 4);
        if (picks.length) {
          $('[data-recent-grid]', rec).innerHTML = picks.map(function (p) { return cardHTML(p); }).join('');
          rec.hidden = false;
        }
      }
    }

    // hover a colour to preview it on the big photo
    var prev = $('[data-preview-img]', root);
    var sibLabel = $('[data-sib-label]', root);
    if (prev && finePointer) {
      $$('[data-preview]', root).forEach(function (a) {
        var show = function () {
          if (a.classList.contains('is-current')) return;
          prev.src = a.getAttribute('data-preview');
          prev.hidden = false;
          requestAnimationFrame(function () { prev.classList.add('is-on'); });
          if (sibLabel) sibLabel.textContent = a.getAttribute('data-preview-name');
        };
        var hide = function () {
          prev.classList.remove('is-on');
          if (sibLabel) sibLabel.textContent = sibLabel.getAttribute('data-default');
        };
        a.addEventListener('mouseenter', show);
        a.addEventListener('mouseleave', hide);
        a.addEventListener('focus', show);
        a.addEventListener('blur', hide);
      });
    }

    // full-screen photo viewer
    var zoom = $('[data-zoom]', root);
    if (main && lightbox) {
      var shots = $$('[data-full]', main).map(function (el) { return el.getAttribute('data-full'); });
      var at = 0;
      var lbImg = $('[data-lb-img]'), lbCount = $('[data-lb-count]');
      var show = function (n) {
        if (!shots.length) return;
        at = (n + shots.length) % shots.length;
        lbImg.src = shots[at];
        lbCount.textContent = (at + 1) + ' / ' + shots.length;
        $('[data-lb-prev]').hidden = $('[data-lb-next]').hidden = shots.length < 2;
      };
      var openLb = function () {
        var vis = $$('[data-media-id]', main).filter(function (el) { return !el.hidden; })[0];
        var idx = vis ? $$('[data-full]', main).indexOf(vis) : 0;
        show(idx < 0 ? 0 : idx);
        lightbox.open();
      };
      if (zoom) zoom.addEventListener('click', openLb);
      main.addEventListener('click', function (e) {
        if (e.target.closest('button, a')) return;
        if (e.target.tagName === 'IMG') openLb();
      });
      $('[data-lb-prev]').addEventListener('click', function () { show(at - 1); });
      $('[data-lb-next]').addEventListener('click', function () { show(at + 1); });
      lightbox.el.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(at - 1);
        if (e.key === 'ArrowRight') show(at + 1);
      });
      var x0 = null;
      lightbox.el.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      lightbox.el.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) show(at + (dx < 0 ? 1 : -1));
      });
      lightbox.el.addEventListener('click', function (e) {
        if (e.target === lightbox.el || e.target.classList.contains('lightbox-panel')) lightbox.close();
      });
    }

    // sticky add-to-cart bar
    var addBtn = $('[data-add]', root);
    var sticky = $('[data-sticky-atc]');
    if (sticky && addBtn) {
      sticky.hidden = false;
      var ticking = false;
      var update = function () {
        ticking = false;
        var past = addBtn.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', past);
        document.body.classList.toggle('has-sticky-atc', past);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); return; }
        var form = addBtn.form;
        if (form && form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    // variant picker (for products with options)
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = $('[data-variant-id]', root);
    var wa = $('[data-whatsapp]', root);
    var fieldsets = $$('[data-option-index]', root);
    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option-index]')) return;
      var selected = fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
      fieldsets.forEach(function (fs, i) {
        var l = $('[data-option-label]', fs);
        if (l) l.textContent = selected[i];
      });
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-unavailable');
        return;
      }
      idInput.value = v.id;
      $$('[data-price]').forEach(function (el) { el.textContent = v.price; });
      $$('[data-tabby-amount]', root).forEach(function (el) { el.textContent = money(Math.floor(v.cents / 4)); });
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart \u2014 ' + v.price : addBtn.getAttribute('data-label-soldout');
      if (v.media) showMedia(v.media);
      if (wa) {
        var msg = wa.getAttribute('data-msg').replace('[variant]', v.title);
        wa.href = wa.getAttribute('data-base') + encodeURIComponent(msg);
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    });
  });

  /* ---------- collection filters ---------- */
  (function () {
    var bar = $('[data-filters]'), grid = $('[data-filter-grid]');
    if (!bar || !grid) return;
    var cards = $$('[data-card]', grid);
    if (cards.length < 2) return;
    cards.forEach(function (c, n) {
      var tags = (c.getAttribute('data-tags') || '').split(',');
      c._order = n;
      c._price = Number(c.getAttribute('data-price')) || 0;
      c._design = c.getAttribute('data-design');
      c._style = styleOf(c.getAttribute('data-type'));
      c._colour = colourOf(c.getAttribute('data-colour'), tags);
    });
    var facets = { style: {}, design: {}, colour: {} };
    cards.forEach(function (c) {
      if (c._style) { facets.style[c._style.key] = facets.style[c._style.key] || { name: c._style.name, n: 0 }; facets.style[c._style.key].n++; }
      if (c._design) { facets.design[c._design] = facets.design[c._design] || { name: c._design, n: 0 }; facets.design[c._design].n++; }
      if (c._colour) { facets.colour[c._colour.key] = facets.colour[c._colour.key] || { name: c._colour.name, hex: c._colour.hex, n: 0 }; facets.colour[c._colour.key].n++; }
    });
    var state = { style: [], design: [], colour: [], sort: 'featured' };
    // read ?style=trucker&colour=black from the address
    try {
      var qs = new URL(window.location.href).searchParams;
      ['style', 'design', 'colour'].forEach(function (k) { if (qs.get(k)) state[k] = qs.get(k).split(','); });
      if (qs.get('sort')) state.sort = qs.get('sort');
    } catch (e) {}

    Object.keys(facets).forEach(function (k) {
      var row = $('[data-facet-row="' + k + '"]', bar), box = $('[data-facet="' + k + '"]', bar);
      var keys = Object.keys(facets[k]);
      if (keys.length < 2) { row.hidden = true; return; }
      box.innerHTML = keys.map(function (key) {
        var f = facets[k][key];
        return '<button type="button" class="chip" data-chip="' + esc(k) + '" data-value="' + esc(key) + '" aria-pressed="false">' +
          (f.hex ? '<span class="sw" style="background:' + f.hex + '"></span>' : '') +
          esc(f.name) + '<span class="n">' + f.n + '</span></button>';
      }).join('');
    });
    var sortSel = $('[data-sort]', bar);
    sortSel.value = state.sort;
    bar.hidden = false;

    function val(c, k) { return k === 'style' ? (c._style && c._style.key) : k === 'design' ? c._design : (c._colour && c._colour.key); }
    // does card c pass every facet, with facet `k` replaced by the single value `v` (if given)?
    function matches(c, k, v) {
      return ['style', 'design', 'colour'].every(function (f) {
        if (f === k) return val(c, f) === v;
        return !state[f].length || state[f].indexOf(val(c, f)) > -1;
      });
    }
    function apply(animate) {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        if (ok) shown++;
        if (ok && c.hidden) {
          c.hidden = false;
          if (animate && !reduceMotion) { c.classList.add('is-entering'); requestAnimationFrame(function () { requestAnimationFrame(function () { c.classList.remove('is-entering'); }); }); }
        } else if (!ok) c.hidden = true;
      });
      var sorted = cards.slice().sort(function (a, b) {
        if (state.sort === 'price-asc') return a._price - b._price || a._order - b._order;
        if (state.sort === 'price-desc') return b._price - a._price || a._order - b._order;
        if (state.sort === 'title') return a._design.localeCompare(b._design) || a._order - b._order;
        return a._order - b._order;
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
      // live counts: how many caps each chip would show with the other filters kept
      $$('[data-chip]', bar).forEach(function (b) {
        var k = b.getAttribute('data-chip'), v = b.getAttribute('data-value');
        var on = state[k].indexOf(v) > -1;
        var n = cards.filter(function (c) { return matches(c, k, v); }).length;
        b.setAttribute('aria-pressed', String(on));
        $('.n', b).textContent = n;
        b.disabled = !on && n === 0;
      });
      var active = state.style.length + state.design.length + state.colour.length;
      $('[data-filter-count]', bar).textContent = active ? shown + ' of ' + cards.length + ' caps' : cards.length + ' caps';
      $$('[data-filter-clear]').forEach(function (b) { if (b.closest('[data-filters]')) b.hidden = !active; });
      $('[data-filters-active]', bar).textContent = active ? '(' + active + ')' : '';
      var empty = $('[data-filter-empty]');
      if (empty) empty.hidden = shown > 0;
      grid.hidden = shown === 0;
      try {
        var u = new URL(window.location.href);
        ['style', 'design', 'colour'].forEach(function (k) { if (state[k].length) u.searchParams.set(k, state[k].join(',')); else u.searchParams.delete(k); });
        if (state.sort !== 'featured') u.searchParams.set('sort', state.sort); else u.searchParams.delete('sort');
        history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip]');
      if (chip) {
        var k = chip.getAttribute('data-chip'), v = chip.getAttribute('data-value');
        var i = state[k].indexOf(v);
        if (i > -1) state[k].splice(i, 1); else state[k].push(v);
        apply(true);
      }
      var t = e.target.closest('[data-filters-toggle]');
      if (t) {
        var open = bar.classList.toggle('is-open');
        t.setAttribute('aria-expanded', String(open));
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-filter-clear]')) return;
      state.style = []; state.design = []; state.colour = [];
      apply(true);
    });
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(false); });
    apply(false);
  })();

  /* ---------- cap finder ---------- */
  $$('[data-finder]').forEach(function (root) {
    var order = ['style', 'design', 'tone'];
    var picks = {};
    var step = 0;
    var steps = order.map(function (k) { return $('[data-step="' + k + '"]', root); });
    var results = $('[data-finder-results]', root);
    var bar = $('[data-finder-bar]', root), label = $('[data-finder-step-label]', root);
    var back = $('[data-finder-back]', root), restart = $('[data-finder-restart]', root);
    function go(n) {
      step = n;
      steps.forEach(function (s, i) {
        var on = i === n;
        if (on) { s.hidden = false; requestAnimationFrame(function () { s.classList.add('is-active'); }); }
        else { s.classList.remove('is-active'); s.hidden = true; }
      });
      results.hidden = n < order.length;
      bar.style.width = Math.round(Math.min(n, order.length) / order.length * 100) + '%';
      label.textContent = n < order.length ? 'Step ' + (n + 1) + ' of ' + order.length : 'Your matches';
      back.hidden = n === 0;
      restart.hidden = n < order.length;
      if (n >= order.length) showResults();
    }
    function score(p) {
      var s = 0, max = 0;
      if (picks.style && picks.style !== 'any') { max += 3; if (p.info.style && (p.info.style.key === picks.style || p.info.style.group === picks.style)) s += 3; }
      if (picks.design && picks.design !== 'any') { max += 3; if (p.info.design.toLowerCase() === picks.design.toLowerCase()) s += 3; }
      if (picks.tone && picks.tone !== 'any') { max += 2; if (p.info.colour && p.info.colour.tone === picks.tone) s += 2; }
      return { s: s, max: max };
    }
    function showResults() {
      var grid = $('[data-finder-grid]', root), title = $('[data-finder-title]', root);
      var ranked = catalog.filter(function (p) { return p.available !== false; }).map(function (p, i) {
        var sc = score(p); return { p: p, s: sc.s, max: sc.max, i: i };
      }).sort(function (a, b) { return b.s - a.s || a.i - b.i; });
      var perfect = ranked.filter(function (r) { return r.s === r.max; });
      var list = (perfect.length ? perfect : ranked).slice(0, 4);
      title.textContent = perfect.length
        ? (perfect.length === 1 ? 'This one\u2019s yours.' : perfect.length + ' caps fit you perfectly.')
        : 'No exact match \u2014 these come closest.';
      grid.className = 'grid finder-grid cols-' + Math.max(2, list.length);
      grid.innerHTML = list.map(function (r) {
        return cardHTML(r.p, { badge: r.s === r.max && r.max > 0 ? 'Match' : '' });
      }).join('');
      if (!reduceMotion) $$('.card', grid).forEach(function (c, i) { c.style.animationDelay = (i * 70) + 'ms'; c.classList.add('pop-in'); });
    }
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-pick]');
      if (opt && step < order.length) {
        picks[order[step]] = opt.getAttribute('data-pick');
        $$('[data-pick]', steps[step]).forEach(function (b) { b.setAttribute('aria-pressed', String(b === opt)); });
        setTimeout(function () { go(step + 1); }, reduceMotion ? 0 : 160);
        return;
      }
      if (e.target.closest('[data-finder-back]')) go(Math.max(0, step - 1));
      if (e.target.closest('[data-finder-restart]')) { picks = {}; $$('[data-pick]', root).forEach(function (b) { b.removeAttribute('aria-pressed'); }); go(0); }
    });
    if (!catalog.length) { root.hidden = true; return; }
    go(0);
  });

  /* ---------- scroll reveal ---------- */
  (function () {
    if (C.animations === false || reduceMotion) return;
    var els = $$('[data-reveal], main .shopify-section > section:not(.product)');
    els = els.filter(function (el, i, a) { return a.indexOf(el) === i && el.getBoundingClientRect().top > window.innerHeight * 0.9; });
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('reveal'); });
    var pending = els.slice(), ticking = false;
    function check() {
      ticking = false;
      var limit = window.innerHeight * 0.92;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < limit) { el.classList.add('is-in'); return false; }
        return true;
      });
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  })();

  /* ---------- start ---------- */
  if (drawer) setTimeout(function () { if (!Cart.state) Cart.get().catch(function () {}); }, 1500);
  window.WTC = { Cart: Cart, openCart: openCart, openQuick: openQuick, money: money, catalog: catalog };
})();
